import {
  ENotice,
  ENoticeDraft,
  EOrganization,
  ESnapshot,
  ESnapshotExists,
  ETemplate,
  exists,
  TemplateSpecs
} from 'lib/types';
import sanitize from 'sanitize-html';
import api from 'api';
import {
  buildTemplateSpecsRequest,
  getDisplayBorderWidthInInches
} from 'lib/indesign/templateSpecs';
import { callIndesignTemplateSpecs } from 'utils/indesign';
import { logAndCaptureMessage } from 'utils';

export const countWords = (html: string) => {
  const text = sanitize(html, {
    allowedTags: [],
    textFilter(text) {
      return `${text} `;
    }
  });
  if (!text) return 0;

  const textCleaned = text.trim().replace(/&nbsp;/g, ' ');
  return textCleaned.split(/\s+/).length;
};

export const slackInvalidHtml = async (notice: ESnapshot<ENoticeDraft>) => {
  logAndCaptureMessage('Notice failed HTML validation', {
    noticeId: notice.id
  });

  await api.post('notifications/slack', {
    message: `Liner Length Exceeded\n*ID:* ${notice.id}\n`
  });
};

// This limit is arbitrary!
export const MAX_CONFIRMED_HTML_WORDS = 18000;

export const validateHtml = (html: string) => {
  return countWords(html) < MAX_CONFIRMED_HTML_WORDS;
};

export const getTemplateSpecs = async (
  newspaper: ESnapshotExists<EOrganization>,
  adTemplate: ESnapshotExists<ETemplate>,
  notice: ESnapshotExists<ENotice>,
  columns: number
): Promise<TemplateSpecs | undefined> => {
  if (!newspaper || !exists(newspaper)) return;

  const request = buildTemplateSpecsRequest({
    newspaper,
    adTemplate,
    notice,
    columns
  });

  const res = await callIndesignTemplateSpecs({ request });

  return {
    ...res.data,
    borderWidthInInches: getDisplayBorderWidthInInches(newspaper)
  };
};
